var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('img',{staticStyle:{"height":"60px"},attrs:{"src":`${_vm.$assetsBase}images/icons/fapps/penta-full.svg`,"alt":"Penta App"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }